export default __webpack_public_path__ + "images/5c94f0724adf5f881ad95d3535c77f14-Eventbrite_Halloween_HomepageC_1920x544.webp";